/**
 * Header Responsive Frontend Script
 *
 * Gère les comportements spécifiques du header responsif
 */

class HeaderResponsive {
	constructor() {
		document.body.classList.add('header-js-initialized');
		this.init();
	}

	init() {
		// Attendre que le DOM soit chargé
		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", () => this.setup());
		} else {
			this.setup();
		}
	}

	setup() {
		// Gérer les headers sticky/fixed
		this.handleStickyHeaders();

		// Gérer le redimensionnement de la fenêtre
		window.addEventListener("resize", () => {
			this.handleResponsiveSwitch();
			this.updateBodyPadding();
		});

		// Initial check
		this.handleResponsiveSwitch();

		// Appliquer le padding au body sur les pages hors home
		this.updateBodyPadding();

		// Vérifier si nous sommes sur la home
		const isHome = document.body.classList.contains("home");

		// Appliquer le comportement transparent/invert uniquement sur la home
		if (isHome) {
			const headers = document.querySelectorAll(
				".header--transparent-home .header-responsive__container, .header--transparent .header-responsive__container",
			);
			headers.forEach((header) => {
				const setBg = () => {
					if (window.scrollY > 10) {
						header.style.backgroundColor = "#fff";
						header.classList.add("header--scrolled");
					} else {
						header.style.backgroundColor = "transparent";
						header.classList.remove("header--scrolled");
					}
				};
				window.addEventListener("scroll", setBg);
				setBg(); // état initial
			});
		} else {
			// Sur les autres pages, retirer la classe transparent-home pour éviter tout comportement indésirable
			const transparentHeaders = document.querySelectorAll(
				".header--transparent-home, .header--transparent",
			);
			transparentHeaders.forEach((header) => {
				header.classList.remove("header--transparent-home");
				header.classList.remove("header--transparent");
			});
		}

		// Effet slide down sur le sous-menu au hover (desktop classique)
		this.setupDesktopSubmenuSlideDown();
	}

	/**
	 * Ajoute le padding-top au body correspondant à la hauteur du header
	 * sauf sur la home avec header transparent
	 */
	updateBodyPadding() {
		// Vérifier si nous sommes sur la home et si le header a une option de transparence
		const isHome = document.body.classList.contains("home");
		const hasTransparentHeader =
			document.querySelector(
				".header--transparent-home, .header--transparent",
			) !== null;

		// Sur la home avec header transparent, ne pas ajouter de padding
		if (isHome && hasTransparentHeader) {
			document.body.style.paddingTop = "0";
			return;
		}

		// Forcer le background blanc sur les autres pages même si header--transparent-home est présent
		if (!isHome && hasTransparentHeader) {
			const transparentHeaders = document.querySelectorAll(
				".header--transparent-home .header-responsive__container, .header--transparent .header-responsive__container",
			);
			transparentHeaders.forEach((header) => {
				header.style.backgroundColor = "#fff";
				header.classList.add("header--scrolled");
			});
		}

		// Déterminer quel container de header est actuellement visible
		const isMobile =
			window.innerWidth <=
			(parseInt(
				document.querySelector(".header-responsive--dual-version")?.dataset
					.breakpoint,
			) || 782);

		// Sélectionner le container de header approprié
		const container = isMobile
			? document.querySelector(".header-responsive__container--mobile")
			: document.querySelector(".header-responsive__container--desktop");

		// Si le container est trouvé et qu'il est positionné en fixed ou sticky
		if (container && this.isFixed(container)) {
			// Obtenir la hauteur réelle du header
			const headerHeight = container.offsetHeight;
			// Appliquer cette hauteur comme padding-top au body
			document.body.style.paddingTop = `${headerHeight}px`;
		}
	}

	handleStickyHeaders() {
		const headers = document.querySelectorAll(
			".header-responsive--dual-version",
		);

		headers.forEach((header) => {
			const mobileContainer = header.querySelector(
				".header-responsive__container--mobile",
			);
			const desktopContainer = header.querySelector(
				".header-responsive__container--desktop",
			);

			// Ajouter classes au body si headers fixed
			if (mobileContainer && this.isFixed(mobileContainer)) {
				document.body.classList.add("has-fixed-header-mobile");
			}

			if (desktopContainer && this.isFixed(desktopContainer)) {
				document.body.classList.add("has-fixed-header-desktop");
			}
		});
	}

	isFixed(element) {
		const styles = window.getComputedStyle(element);
		return styles.position === "fixed" || styles.position === "sticky";
	}

	handleResponsiveSwitch() {
		const headers = document.querySelectorAll(
			".header-responsive--dual-version",
		);

		headers.forEach((header) => {
			const breakpoint = parseInt(header.dataset.breakpoint) || 782;
			const isMobile = window.innerWidth <= breakpoint;

			// Dispatch événement personnalisé pour les autres scripts
			header.dispatchEvent(
				new CustomEvent("headerResponsiveSwitch", {
					bubbles: true,
					detail: {
						isMobile: isMobile,
						breakpoint: breakpoint,
						currentWidth: window.innerWidth,
					},
				}),
			);
		});
	}

	/**
	 * Ajoute l'effet slide down sur les sous-menus du header desktop classique
	 */
	setupDesktopSubmenuSlideDown() {
    const desktopHeaders = document.querySelectorAll(
        ".header-desktop-container--classic .wp-block-navigation li.has-child, .header-desktop-container--classic .wp-block-navigation li.wp-block-navigation-submenu"
    );

    desktopHeaders.forEach((li) => {
        li.addEventListener("mouseenter", () => {
            li.classList.add("open");
        });
        li.addEventListener("mouseleave", () => {
            li.classList.remove("open");
        });
    });
}
}

// Initialiser le header responsif
new HeaderResponsive();
